import e from "../../utils/classNames.js";
import { CheckboxIcon as t } from "./CheckboxIcon.js";
import { useEffect as n, useRef as r } from "react";
import { noop as i } from "es-toolkit/function";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
//#region src/components/checkbox/Checkbox.tsx
var s = 16, c = "vertical", l = "horizontal", u = (l) => {
	let { checked: u, children: d, className: f, custom: p = !1, defaultChecked: m, disabled: h = !1, error: g = !1, iconName: _, icon: v, iconLabelPosition: y = c, iconSize: b = s, id: x = l.name, indeterminate: S = !1, inline: C = !1, inputRef: w, label: T, name: E, onChange: D = i, onClick: O = i, required: k = !1, right: A, size: j, tabIndex: M = 0, ...N } = l, P = _ ?? v ?? "", F = r(null);
	n(() => {
		let e = F.current?.firstChild;
		e && (e.indeterminate = S);
	}, [S, F.current]);
	let I = (e) => {
		switch (e.key) {
			case " ":
				L(e);
				break;
			case "Enter": L(e);
		}
	}, L = (e) => {
		if (e.preventDefault(), h) return;
		let t = F.current?.firstChild;
		t.indeterminate &&= !1, t.checked = !t.checked, O(e), D(e);
	}, R = T || d, z = e("checkbox", C && "checkbox-inline", j === "large" && "checkbox-large", A && "checkbox-right", h && "disabled", f), B = e(g && "error", j === "large" && "large", S && "indeterminate", f), V = !!P, H = p && d, U = !P && !p;
	return /* @__PURE__ */ o("label", {
		...N,
		className: z,
		tabIndex: M,
		htmlFor: x,
		onKeyDown: I,
		ref: F,
		children: [
			/* @__PURE__ */ a("input", {
				id: x,
				name: E,
				type: "checkbox",
				checked: u,
				required: k,
				defaultChecked: m,
				disabled: h,
				className: B,
				onClick: O,
				onChange: D,
				ref: w
			}),
			V && /* @__PURE__ */ a(t, {
				iconName: P,
				iconSize: b,
				iconLabelPosition: y,
				text: R
			}),
			U && /* @__PURE__ */ a("span", {
				className: "checkbox-text",
				children: R && /* @__PURE__ */ a("span", { children: R })
			}),
			H && d
		]
	});
};
u.ICON_LABEL_VERTICAL = c, u.ICON_LABEL_HORIZONTAL = l;
//#endregion
export { u as default };

//# sourceMappingURL=Checkbox.js.map